import { useNavigate, useParams } from "react-router-dom";
import { useEditQna } from "../hooks/useEditQna";
import QnaReplyEditRow from "./QnaReplyEditRow";
import { useEffect, useState } from "react";
import { useEditQnaReply } from "../hooks/useEditQnaReply";
import QnaReplyCreateRow from "./QnaReplyCreateRow";
import { useReadHandlerData } from "../../rma/hooks/useReadHandlerData";
import { useUser } from "../../../../util/userContext/UserContext";
import AuthorityChecker from "../../../../components/common/authorityGuard/AuthorityChecker";

export const QnaDetail = () => {
    const { id } = useParams();
    const { user } = useUser();
    const navigate = useNavigate();

    const { updateQnaState, updateTechnicalSupport, inputData, setInputData } = useEditQna();
    const { deleteQnaReply } = useEditQnaReply({ qnaId: id ?? '' });
    const { data: handlerData } = useReadHandlerData();
    const [editRowKeyArr, setEditRowKeyArr] = useState<string[]>([]);

    useEffect(() => {
        if (inputData?.userId && user?.userId) {
            if (inputData.userId !== user.userId) {
                alert("잘못된 접근입니다.");
                navigate(`${process.env.PUBLIC_URL}/support/qna/list`, { replace: true });
            }
        }
    }, [id, user]);

    if (!id) {
        alert("잘못된 접근입니다.");
        navigate(`${process.env.PUBLIC_URL}/support/qna/list`, { replace: true });
        return <></>;
    }

    const addEditRowKey = (key: string) => {
        if (!editRowKeyArr.includes(key))
            setEditRowKeyArr([...editRowKeyArr, key]);
    }

    const removeEditRowKey = (key: string) => {
        setEditRowKeyArr(editRowKeyArr.filter((item) => item !== key));

        // 신규 작성 중이던 답변은 취소 시 목록에서 제거
        if (key === '') {
            setInputData((prev: any) => ({
                ...prev,
                replyList: prev.replyList.filter((reply: any) => reply.qnaReplyId !== '')
            }));
        }
    };

    return (
        <>
            <div className="content_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">1:1문의 상세보기</h3>
                    <div className="filter_toolbar">
                        <button
                            className="btn btn-outline-primary w-100px h-38px"
                            onClick={() => navigate(-1)}>
                            <img src={process.env.PUBLIC_URL + "/assets/images/icon_hamburger_btn.png"} alt="" />
                            목록
                        </button>
                        <AuthorityChecker authorityNames={['qnaWriteYn']}>
                            <button
                                className="btn btn-secondary w-100px h-38px"
                                onClick={() => navigate(`${process.env.PUBLIC_URL}/support/qna/update/${id}`, { replace: true })}>
                                수정
                            </button>
                        </AuthorityChecker>
                    </div>
                </div>
                <div className="table_scroll mb-0">
                    <table className="table table-bordered my_table table_detail">
                        <tbody>
                            <tr>
                                <th colSpan={2} style={{ width: "12.5%" }}>제목</th>
                                <td>{inputData?.title || ''}</td>
                            </tr>
                            <tr>
                                <th colSpan={2}>작성자/등록일</th>
                                <td>{inputData?.userName} | {inputData?.regAt}</td>
                            </tr>
                            <tr>
                                <th rowSpan={6}>기본정보</th>
                                <th style={{ width: "6.5%" }}>유형</th>
                                <td>{inputData?.topicType}</td>
                            </tr>
                            <tr>
                                <th>제품군</th>
                                <td>{inputData?.newName}</td>
                            </tr>
                            <tr>
                                <th>벤더</th>
                                <td>{inputData?.productVendor}</td>
                            </tr>
                            <tr>
                                <th>카테고리</th>
                                <td>{inputData?.productCategory}</td>
                            </tr>
                            <tr>
                                <th>상태</th>
                                <td>
                                    <select
                                        className="form-select text-success w-150px"
                                        name={"questionState"}
                                        value={inputData?.questionState}
                                        disabled={user?.authority?.qnaWriteYn !== 'Y'}
                                        onChange={(e) => updateQnaState({
                                            qnaId: inputData.qnaId,
                                            questionState: e.target.value as '접수' | '진행' | '완료'
                                        })}>
                                        <option value={"접수"}>접수</option>
                                        <option value={"진행"}>진행</option>
                                        <option value={"완료"}>완료</option>
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <th>기술지원</th>
                                <td>
                                    <select
                                        className="form-select text-success w-150px"
                                        name={"technicalSupportId"}
                                        value={inputData?.technicalSupportId ?? ''}
                                        disabled={user?.authority?.qnaWriteYn !== 'Y'}
                                        onChange={(e) => updateTechnicalSupport({
                                            qnaId: inputData.qnaId,
                                            technicalSupportId: Number(e.target.value)
                                        })}>
                                        <option value={''}>미지원</option>
                                        {(handlerData ?? []).map((item: any) => <option
                                            value={item.userId}>{`${item.userName} ${item.title}`}</option>)}
                                    </select>
                                </td>
                            </tr>
                            <tr style={{ height: "249px" }}>
                                <th colSpan={2}>내용</th>
                                <td style={{ verticalAlign: "top" }}
                                    dangerouslySetInnerHTML={{ __html: inputData?.body ?? '' }}></td>
                            </tr>
                            <tr>
                                <th colSpan={2}>첨부파일</th>
                                <td>
                                    <div className="tbl_files_outer">
                                        {inputData?.fileVOList.length !== 0 && <ul className="list_files">
                                            {inputData?.fileVOList.map((item: any) => <li>
                                                <a href={encodeURI(`${process.env.REACT_APP_SERVER_URL}api/customer/support/download_support_file?fileKey=${item.fileKey}&fileOrgname=${item.fileOrgname}&fileUrl=${item.fileUrl}`)}>
                                                    {item.fileOrgname}
                                                </a>
                                            </li>)}
                                        </ul>}
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="content_wrap">
                <h3 className="comment_heading">답변</h3>
                {/* <AuthorityChecker authorityNames={['qnaWriteYn']}>
                    <button className="btn btn-dark w-100px"
                        onClick={() => {
                            addEditRowKey('');
                            setInputData((prev: any) => {
                                const newOneExist = (prev?.replyList ?? []).filter((reply: any) => reply.qnaReplyId === '');
                                if (newOneExist.length === 0)
                                    return ({
                                        ...prev,
                                        replyList: [...prev.replyList, {
                                            qnaReplyId: '',
                                            isMain: (inputData?.replyList ?? []).filter((reply: any) => reply.isMain === 'Y').length === 0 ? 'Y' : 'N',
                                            qnaId: id
                                        }]
                                    })
                                else return prev;
                            });
                        }}>
                        답변달기
                    </button>
                </AuthorityChecker> */}
                <AuthorityChecker authorityNames={['qnaReadYn']}>
                    <button className="btn btn-dark w-100px"
                        onClick={() => {
                            addEditRowKey('');
                            setInputData((prev: any) => {
                                const newOneExist = (prev?.replyList ?? []).filter((reply: any) => reply.qnaReplyId === '');
                                if (newOneExist.length === 0)
                                    return ({
                                        ...prev,
                                        replyList: [...prev.replyList, {
                                            qnaReplyId: '',
                                            isMain: (inputData?.replyList ?? []).filter((reply: any) => reply.isMain === 'Y').length === 0 ? 'Y' : 'N',
                                            qnaId: id
                                        }]
                                    })
                                else return prev;
                            });
                        }}>
                        답변달기
                    </button>
                </AuthorityChecker>

                {(inputData?.replyList ?? []).map((item: any) => !editRowKeyArr.includes(item.qnaReplyId) ?
                    <div className="comment_item">
                        <div className="comment_top">
                            <div className="user_detail">
                                <div>
                                    <img src={process.env.PUBLIC_URL + "/assets/images/icon_user_comment.png"} alt="" />
                                </div>
                                <div>
                                    {item.userName}<br />
                                    {item.regAt}
                                </div>
                            </div>
                            <div className="d-flex justify-content-end mt-15px">
                                <AuthorityChecker authorityNames={['qnaWriteYn']}>
                                    {item.userId === user?.userId &&
                                        <a className="me-5px" onClick={() => addEditRowKey(item.qnaReplyId)}><img
                                            src={process.env.PUBLIC_URL + "/assets/images/icon_edit_post.png"} alt="" /></a>}
                                    {/* {item.isMain !== 'Y' && item.userId === user?.userId &&
                                        <a className="" onClick={() => deleteQnaReply(item.qnaReplyId)}><img
                                            src={process.env.PUBLIC_URL + "/assets/images/icon_delete_post.png"}
                                            alt=""/></a>} */}
                                    {item.userId === user?.userId && (
                                        <a onClick={() => deleteQnaReply(item.qnaReplyId)}>
                                            <img src={process.env.PUBLIC_URL + "/assets/images/icon_delete_post.png"} alt="" />
                                        </a>
                                    )}
                                </AuthorityChecker>
                            </div>
                        </div>
                        <div className="comment_detail">
                            <div className="message" dangerouslySetInnerHTML={{ __html: item.body }}></div>
                            {(item?.fileVOList ?? []).length > 0 && <div className="btn_list_files">
                                {item.fileVOList.map((file: any) => <>
                                    <button className="btn btn-outline-secondary"
                                        onClick={() => document.getElementById(`file-${file.fileKey}`)?.click()}>
                                        <a id={`file-${file.fileKey}`}
                                            href={encodeURI(`${process.env.REACT_APP_SERVER_URL}api/customer/support/download_support_file?fileKey=${file.fileKey}&fileOrgname=${file.fileOrgname}&fileUrl=${file.fileUrl}`)}></a>
                                        {file.fileOrgname}&nbsp;
                                        <img src={process.env.PUBLIC_URL + "/assets/images/icon_comment_download.png"}
                                            alt="" />
                                    </button>
                                    &nbsp;
                                </>)}
                            </div>}
                        </div>
                    </div> :
                    item.qnaReplyId ? <QnaReplyEditRow data={item} onCanceled={removeEditRowKey} qnaId={id} /> :
                        <QnaReplyCreateRow data={item} onCanceled={removeEditRowKey} qnaId={id} />)}
            </div>
        </>
    );
}